"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_code_blocks_1 = require("react-code-blocks");
const CgpEvaluator_1 = __importStar(require("./CgpEvaluator"));
const CgpGenerator_1 = require("./CgpGenerator");
const CgpMutator_1 = __importDefault(require("./CgpMutator"));
exports.default = () => {
    const [generation, setGeneration] = React.useState(-1);
    const [bestModel, setBestModel] = React.useState("");
    const [accuracy, setAccuracy] = React.useState(-1);
    const MIDDLE_NODES = 20;
    const POOL_SIZE = 50;
    const [pool, setPool] = React.useState((0, CgpGenerator_1.generateCgpPool)(POOL_SIZE, 4, MIDDLE_NODES, 3));
    const [fitnesses, setFitnesses] = React.useState(Array(POOL_SIZE).fill(0));
    function getBest(localPool, localFit) {
        const fitActual = localFit.filter((value) => Number.isFinite(value));
        const bestIdx = localFit.indexOf(Math.max(...fitActual));
        return localPool[bestIdx];
    }
    function evaluateFitnesses(localPool) {
        const fitnesses = localPool.map((prog) => {
            return (0, CgpEvaluator_1.default)(prog, 4, MIDDLE_NODES, 3);
        });
        return fitnesses;
        //setFitnesses(fitnesses);
    }
    function mutatePool(localPool) {
        const newPool = localPool.map((prog) => {
            return (0, CgpMutator_1.default)(prog, 4, MIDDLE_NODES, 3);
        });
        return newPool;
        //setPool(newPool);
    }
    function runTournamentSelection(localPool, localFit) {
        const newPool = new Array();
        for (let i = 0; i < POOL_SIZE; i++) {
            const idxA = Math.floor(Math.random() * POOL_SIZE);
            const idxB = Math.floor(Math.random() * POOL_SIZE);
            if (localFit[idxA] > localFit[idxB]) {
                newPool.push(localPool[idxA]);
            }
            else {
                newPool.push(localPool[idxB]);
            }
        }
        return newPool;
    }
    return (React.createElement("div", null,
        React.createElement("p", null, "Now that we have all the elements to run generations of genetic programs, let's see if it'll actually solve the iris problem."),
        React.createElement("p", null, "To be considered solved, we'll shoot for an accuracy (not fitness) of 95%, as that's comparable to other models."),
        React.createElement("p", null,
            "NOTE: As we're not showing every program and we are trying to solve the problem, the number of middle nodes is now ",
            MIDDLE_NODES,
            " and the pool size is ",
            POOL_SIZE,
            "."),
        React.createElement(react_code_blocks_1.CodeBlock, { text: `Generation: ${generation}
Best model: ${bestModel}
Accuracy: ${accuracy}` }),
        React.createElement("button", { type: "button", onClick: (e) => {
                const localPool = (0, CgpGenerator_1.generateCgpPool)(POOL_SIZE, 4, MIDDLE_NODES, 3);
                const localFit = evaluateFitnesses(localPool);
                // Find the best:
                const best = getBest(localPool, localFit);
                setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                setPool(localPool);
                setFitnesses(localFit);
                setGeneration(1);
                setBestModel(best);
            } }, "Reset Pool"),
        React.createElement("button", { type: "button", onClick: (e) => {
                // Nice part is we already have the fitnesses:
                const newPool1 = runTournamentSelection(pool, fitnesses);
                const newPool2 = mutatePool(newPool1);
                const newFitnesses2 = evaluateFitnesses(newPool2);
                // Find the best:
                const best = getBest(newPool2, newFitnesses2);
                setAccuracy((0, CgpEvaluator_1.evaluateProgramAccuracy)(best, 4, MIDDLE_NODES, 3));
                setPool(newPool2);
                setFitnesses(newFitnesses2);
                setGeneration(generation + 1);
                setBestModel(best);
            } }, "Run generation")));
};
